const GOOGLE_SLIDES_HOST = "docs.google.com";
const GOOGLE_SLIDES_PRESENTATION_PATH =
  /^\/presentation\/(?:u\/\d+\/)?d\/(?!e(?:\/|$))[^/]+(?:\/|$)/i;
const GOOGLE_SLIDES_PRESENTATION_KEY_PATTERN =
  /(?:https?:\/\/)?(?:www\.)?docs\.google\.com\/presentation\/(?:u\/\d+\/)?d\/(?!e(?:\/|$))([^/?#]+)/i;

export function extractGoogleSlidesPresentationKey(rawValue) {
  const value = String(rawValue || "").trim();
  if (!value) return "";
  const match = GOOGLE_SLIDES_PRESENTATION_KEY_PATTERN.exec(value);
  return match?.[1] || "";
}

export function toReactGoogleSlidesUrl(rawValue) {
  const presentationKey = extractGoogleSlidesPresentationKey(rawValue);
  return presentationKey
    ? `https://docs.google.com/presentation/d/${presentationKey}`
    : "";
}

export function buildGoogleSlidesEmbedSrc(rawValue, {
  loop = false,
  slideDuration = null,
  showControls = false,
  position = null,
} = {}) {
  const presentationKey = extractGoogleSlidesPresentationKey(rawValue);
  if (!presentationKey) {
    return "";
  }

  let src = `https://docs.google.com/presentation/d/${presentationKey}/embed?loop=${loop ? "true" : "false"}`;
  const durationSeconds = Number(slideDuration);
  if (Number.isFinite(durationSeconds) && durationSeconds > 0) {
    src += `&start=true&delayms=${Math.round(durationSeconds * 1000)}`;
  }
  if (!showControls) {
    src += "&rm=minimal";
  }
  const slidePosition = Number(position);
  if (Number.isFinite(slidePosition) && slidePosition > 0) {
    src += `&slide=${slidePosition}`;
  }
  return src;
}

export function toGoogleSlidesEmbedSize(value, fallback) {
  if (value == null || value === "") {
    return fallback;
  }
  return typeof value === "number" ? `${value}px` : value;
}

export function isGoogleSlidesPresentationUrl(rawValue) {
  const value = String(rawValue || "").trim();
  if (!value) return false;

  try {
    const normalizedValue = /^https?:\/\//i.test(value) ? value : `https://${value}`;
    const parsedUrl = new URL(normalizedValue);
    const hostname = parsedUrl.hostname.replace(/^www\./i, "").toLowerCase();

    return hostname === GOOGLE_SLIDES_HOST
      && GOOGLE_SLIDES_PRESENTATION_PATH.test(parsedUrl.pathname);
  } catch (_) {
    return false;
  }
}
